import { FormControl } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import { DatePicker } from 'v3/shared/components/Inputs/DatePicker/index';
import { ErrorMessage } from 'v3/shared/components/Inputs/styles/defaultStyles';
import { CustomDatePickerProps } from './types';

export const DatePickerFormController: React.FC<CustomDatePickerProps> = ({
  formControl,
  formControlName,
  label,
  disablePast,
  disableFuture,
  shouldDisableDate,
  fullWidth = true,
  minDate,
  maxDate,
  onChangeDatePicker,
  defaultValue,
}) => {
  return (
    <Controller
      name={formControlName}
      control={formControl}
      defaultValue={defaultValue ?? null}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
        return (
          <FormControl fullWidth={fullWidth}>
            <DatePicker
              label={label}
              value={value ?? null}
              onChangeDatePicker={(val) => {
                onChange(val);
                onChangeDatePicker?.(val);
              }}
              disablePast={disablePast}
              shouldDisableDate={shouldDisableDate}
              minDate={minDate}
              maxDate={maxDate}
              disableFuture={disableFuture}
            />
            <ErrorMessage>{error?.message}</ErrorMessage>
          </FormControl>
        );
      }}
    />
  );
};
